<template>
    <div class="history-intercom">
        <div class="normal" v-if="isNormal">
            <div class="real-left" :style="{height:clientHeight}">
                <div class="cut">
                    <span class="nape  " @click="cutPath('/visual-intercom/real-time-intercom')" > 实时对讲   <el-divider  direction="vertical"></el-divider></span>
                    <span class="nape isActive" @click="cutPath('/visual-intercom/history-intercom')" >  历史对讲 </span>
                </div>
<!--                <el-button type="primary" @click="addQuick" style="width: 100%;margin-top: 15px" plain><i class="el-icon-plus"></i> 快速添加 </el-button>-->
                <div class="groupBox">
                    <div class="group pointer" @click="enterChat(group)" v-for="(group ,inx) in groupList" :class="{'is-group':group.id==SelectGroupId?true:false}" :key="inx">
                        {{group.groupName}}
                    </div>
                </div>
            </div>
            <div class="real-right" :style="{height:clientHeight2}">
<!--                <div class="button-box">-->
<!--                    <el-button type="danger" @click="overGroup">结束会议</el-button>-->
<!--                    <el-button type="warning" @click="quitGroup">退出会议</el-button>-->
<!--                </div>-->
                <div class="real-box" >
                    <div class="webSockBOX" >
                        <webSock ref="webSock" :disabled="true" :height="clientHeight2"></webSock>
                    </div>
                    <div class="groupMembers" >
                        <div class="weui-div" @click.stop="toggle">
                            <span class="weui-switch" :class="{'weui-switch-on' : switchValue}" :value="switchValue" ></span>
                            <div class="weui-div-1 weui-div-box " :style="{color:!switchValue?'#fff':'#000',opacity:switchValue?0.3:1}">会议信息</div>
                            <div class="weui-div-2 weui-div-box"  :style="{color:switchValue?'#fff':'#000',opacity: !switchValue?0.3:1}">成员列表</div>
                        </div>
                        <div class="switchValue" v-if="switchValue">
                            <div class="addMembers pointer">
                                <i class="el-icon-plus"></i>   添加群员
                            </div>
                            <div class="groupMembers-list">
                                <div class="members">
                                    <img class="headPortrait" :src="require('../../../../assets/images/system-index/user-logo.jpg')">
                                    <div class="members-info">
                                        <p class="ellipsis" :title="'王尼玛'">姓名:王尼玛</p>
                                        <p class="ellipsis" :title="'19109090909'">手机号:19109090909</p>
                                        <p class="ellipsis"  :title="'第五精神病院'">区域:第五精神病院</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="groupInfo" v-else>
                            <div class="nape">
                                <p class="title">会议号：</p>
                                <p class="content">HG76s8sj </p>
                            </div>
                            <div class="nape">
                                <p class="title">主持人：</p>
                                <p class="content">张三</p>
                            </div>
                            <div class="nape">
                                <p class="title">主持单位：</p>
                                <p class="content">蓬溪县指挥中心</p>
                            </div>
                            <div class="nape">
                                <p class="title">会议时间：</p>
                                <p class="content">2020-8-28 14:24~2020-8-28 18:24</p>
                            </div>
                            <div class="nape">
                                <p class="title">会议概要：</p>
                                <p class="content" style="font-weight: normal">这是一场关于消防演习的会议，邀请了市消防局张警官来普及应急逃生的各项自救/急救知识。这是一场关于消防演习的会议，邀请了市消防局张警官来普及应急逃生的各项自救/急救知识</p>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
        <div class="addGroup" v-else :style="{height:clientHeight}" >
            <div class="addGroup-BG" >
                <div class="module pointer" @click="moduleClick(i+1)" :key="i" v-for="(item,i) in moduleLits">
                    <img class="module-left" :src="item.src">
                    <div class="module-right">
                        <p class="title">{{item.title}}</p>
                        <p class="remark">{{item.remark}}</p>
                    </div>
                </div>



            </div>
        </div>
    </div>

</template>

<script>
    import webSock from "../../../../components/webSock/webSrom"
    import publicAPI from "../../../../api-path/public-api";
    export default {
        name: "real-time-intercom",
        components:{
            webSock
        },
        data(){
            return{
                moduleLits:[
                    {
                        title:'紧急会议',
                        remark:'创建一个立即召开的会议',
                        src:require('../../../../assets/images/system-index/user-logo.jpg'),
                    },
                    {
                        title:'预约会议',
                        remark:'提前预约,更有计划',
                        src:require('../../../../assets/images/system-index/user-logo.jpg'),
                    },
                    {
                        title:'加入会议',
                        remark:'填写会议号加入已创建的会议',
                        src:require('../../../../assets/images/system-index/user-logo.jpg'),
                    },
                    {
                        title:'取消添加',
                        remark:'取消快速添加,返回页面',
                        src:require('../../../../assets/images/system-index/user-logo.jpg'),
                    }
                ],
                isNormal:true,
                clientHeight:'',
                clientHeight2:'',
                screenHeight:'',
                pathList:[],
                groupList:[],//所有群组
                switchValue:true,
                SelectGroupId:'',
            }
        },
        watch:{

        },
        mounted() {
            var _this = this;
            window.onresize = function(){ // 定义窗口大小变更通知事件
                _this.clientHeight = (document.body.clientHeight - 80) +'px';
                _this.screenHeight=  (window.screen.height - 60)+'px';
                _this.clientHeight2 = (document.body.clientHeight - 305) ;
            };
        },
        created() {
            this.clientHeight = (document.body.clientHeight - 80) +'px';
            this.screenHeight=  (window.screen.height - 60)+'px';
            this.clientHeight2 = (document.body.clientHeight - 305) ;
            this.searchSelfGroup()
        },
        methods:{
            searchSelfGroup(){ //根据Id创建的群
                let params={
                    userId:sessionStorage.getItem('userId')
                }
                this.$http.get(publicAPI.searchSelfGroup,{params:params}).then((res=>{
                    if(res.code==200){
                        this.searchAddGroup(res.data.data)
                    }
                }))
            },
            searchAddGroup(list){ //根据Id加入的群
                let params={
                    userId:sessionStorage.getItem('userId')
                }
                this.$http.get(publicAPI.searchAddGroup,{params:params}).then((res=>{
                    if(res.code==200){
                        let obj = {};
                        let  data= [...list,...res.data.data]
                        let peon = data.reduce((cur,next) => {
                            obj[next.id] ? "" : obj[next.id] = true && cur.push(next);
                            return cur;
                        },[]) //设置cur默认类型为数组，并且初始值为空的数组
                        this.groupList=peon;
                        this.SelectGroupId= this.groupList[0].id;
                    }
                }))
            },
            overGroup(){//解散会议 结束会议
                this.$http.get(publicAPI.deleteGroup).then((res=>{
                    if(res.code==200){
                        console.log(res)
                    }
                }))
            },
            quitGroup(){// 退出会议 退出群聊

            },
            cutPath(path){
                this.$router.push(path)
            },
            toggle(){
                this.switchValue = !this.switchValue;
            },
            enterChat(item){
                console.log(item);
                sessionStorage.setItem('groupId',item.id);
                this.SelectGroupId=item.id;
                this.$refs.webSock.ClearChatLogs();
            },
            addQuick(){
                console.log(11)
                this.isNormal=!this.isNormal;
            },
            moduleClick(inx){
                switch (inx) {
                    case 1:
                        console.log(1);
                        break;
                    case 2:
                        console.log(2);
                        break;
                    case 3:
                        console.log(3);
                        break;
                    case 4:
                        this.addQuick()
                        break;
                    default:

                }

            }
        }
    }
</script>

<style lang="less"  scoped>
    @import "index.less";
</style>